module.exports = __webpack_public_path__ + "static/img/steps_3_1.5bf98dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/official/steps_3_1.png
// module id = ynO9
// module chunks = 0